import type { UseFormGetValues, UseFormReset, UseFormSetValue } from 'react-hook-form';
import type { ColumnDraft, FormValues } from './types';

export function resetColumnRelatedFields(reset: UseFormReset<FormValues>, getValues: UseFormGetValues<FormValues>): void {
  reset({
    ...getValues(),
    columns: [],
    contractUkColumns: [],
    customerUkEnabled: false,
    customerUkColumns: [],
  });
}

export function removeNamesFromUkColumns(
  getValues: UseFormGetValues<FormValues>,
  setValue: UseFormSetValue<FormValues>,
  names: Iterable<string>,
  nextDestination: ColumnDraft['destination'],
): void {
  const nameSet = names instanceof Set ? names : new Set(names);
  if (nameSet.size === 0) return;

  if (nextDestination !== 'contract') {
    const cur = getValues('contractUkColumns');
    const next = cur.filter((n) => !nameSet.has(n));
    if (next.length !== cur.length) {
      setValue('contractUkColumns', next, { shouldDirty: true });
    }
  }
  if (nextDestination !== 'customer') {
    const cur = getValues('customerUkColumns');
    const next = cur.filter((n) => !nameSet.has(n));
    if (next.length !== cur.length) {
      setValue('customerUkColumns', next, { shouldDirty: true });
    }
  }
}
